import Layout from "../components/layout";
import Head from "next/head";
import { landingPagesQuery } from "@/lib/queries";
import { getClient, overlayDrafts } from "@/lib/sanity.server";
import SegmentGenerator from "@/components/segment-generator";

export default function TermsOfUse({ pageContent, preview }) {
  return (
    <Layout preview={preview}>
      <Head>
        <title>{pageContent.title}</title>
      </Head>
      <div className="prose-headings:text-left prose-p:text-left w-full md:w-[61.8%] max-w-5xl mx-auto">
        {pageContent.segments?.map((segment) => (
          <div key={segment._id}>
            <SegmentGenerator segment={segment} />
          </div>
        ))}
      </div>
    </Layout>
  );
}

export async function getStaticProps({ preview = false }) {
  const pageContent = overlayDrafts(
    await getClient(preview).fetch(landingPagesQuery, {
      slug: "terms-of-use",
    })
  )[0];
  return {
    props: { pageContent, preview },
  };
}
